/** Вкладка «Сводка»: KPI с дельтами, P&L (группы → статьи), тренд; ниже — справочный блок «Склад»
 *  (не в P&L; один для Ozon и WB). */
import React from "react";

import type { Grain, OzFilters } from "@/api/ozonAnalytics";
import { buildKpis } from "./kpi";
import { useMp } from "./mp";
import { KpiGrid, PnlTable } from "./pnl";
import { useSummary } from "./queries";
import { ErrorBox, Loading } from "./shared";
import { TrendChart } from "./TrendChart";
import { WAREHOUSE_BLOCK_ENABLED } from "../wh-ops/flag";
import { MpWarehouseBlock } from "../wh-ops/MpWarehouseBlock";

export function SummaryTab({
  filters,
  grain,
  onGrain,
  cmpWarning = null,
}: {
  cmpWarning?: string | null;
  filters: OzFilters;
  grain: Grain;
  onGrain: (g: Grain) => void;
}): React.ReactElement {
  const mp = useMp();
  const q = useSummary(mp.id, filters);
  return (
    <div className="space-y-4">
      {q.isLoading && <Loading text="Считаю сводку по витрине…" />}
      {q.isError && <ErrorBox error={q.error} what="сводку" />}
      {q.data && (
        <>
          <KpiGrid kpis={buildKpis(q.data, mp)} warning={cmpWarning} />
          <PnlTable summary={q.data} filters={filters} warning={cmpWarning} />
          <p className="text-xs text-muted-foreground" data-testid="summary-note">
            Выручка − Расходы = Маржа (до налогов). Расходы — все удержания {mp.label} и
            себестоимость (производство с НДС + склад производства); себестоимость считается с
            даты начала себестоимости — у более раннего периода расходов и маржи нет («—»).
            Расходы показаны без минуса, рост расходов — красный; с минусом — компенсации,
            уменьшающие расходы. На графике тренда расходы — столбцами вниз от нуля, в подсказке —
            тоже без минуса.
          </p>
        </>
      )}
      <TrendChart filters={filters} grain={grain} onGrain={onGrain} />
      {WAREHOUSE_BLOCK_ENABLED && <MpWarehouseBlock dateFrom={filters.date_from} dateTo={filters.date_to} />}
    </div>
  );
}
